import React, { useCallback, useState, useEffect } from 'react'
import { useModal } from 'react-modal-hook'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import AccountDisplay from '../../../components/account-display/account-display'
import BeneficiaryDisplay from '../../../components/beneficiary-display/beneficiary-display'
import Modal from '../../../components/Modal/Modal'
import NeoButton from '../../../components/NeoButton/NeoButton'
import LayoutWithAccountCard from '../../../layout/Layout/layout-account-card'
import { InternalTransferSchema } from '../../../schemas/beneficiary-transfer'
import { carouselCurrentItemSelector, getFeatureListSelector } from '../../../selectors'
import DashboardService from '../../../services/dashboard.service'
import { Formik, Form, Field } from 'formik'
import NeoInput from '../../../components/NeoInput/NeoInput'
import InputError from '../../../components/InputError/InputError'
import NeoSuccess from '../../../components/FormComponents/NeoSuccess'
import NeoOTP from '../../../components/FormComponents/NeoOTP'
import Loading from 'custom/assets/loaders/Loading'
import { useTranslation } from 'react-i18next'
import {
  BENEFICIARY_TRANSFER_KEYS,
  AUTH_KEYS,
  SIDENAV_KEYS,
  RECIPTS_KEYS,
  DIALOG_KEYS,
  DEPOSITS_KEYS,
  REQUESTS_KEYS,
  VALIDATION_MESSAGES,
} from '../../../utils/translation-constants'
import BeneficiaryTransferService from '../../../services/beneficiary-transfers.service'
import TermsAndCondition from '../../../components/TermsAndConditions/TermsAndCondition'
import { setAccRefresh } from '../../../actions'
import config from 'custom/config/environment'
import NumberFormat from 'react-number-format'

import validationConfig from 'custom/config/validation.config.json'
const internalTransferConfig = validationConfig['transfers']['internal']

export default function InternalAccountTransfer() {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)
  const [stage, setStage] = useState(1)
  const [otp, setOtp] = useState('')
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [beneDetails, setBeneDetails] = useState({})
  const [formValues, setFormValues] = useState({})
  const [verifyDetails, setVerifyDetails] = useState({})
  const [transferType, setTransferType] = useState({})
  const [currencyList, setCurrencyList] = useState([])
  const [remarksList, setRemarksList] = useState([])
  const [confirmMessage, setConfirmMessage] = useState()
  const currentAccountDetail = useSelector(carouselCurrentItemSelector)
  const { t } = useTranslation()
  const featureList = useSelector(getFeatureListSelector)
  const [successResponse, setSuccessResponse] = useState({})

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{message?.code}</b> : {message?.message}
          </h6>
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={t(DIALOG_KEYS.CLOSE)}
              onClick={() => {
                hideModal()
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [message],
  )
  const [showConfirmModal, hideConfirmModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>{confirmMessage}</h6>
          <div className='mt-4 d-flex justify-content-evenly'>
            <div className='col-6'>
              <NeoButton
                mode='newDesign'
                type='button'
                text={t(DIALOG_KEYS.CONFIRM_YES)}
                onClick={() => {
                  hideConfirmModal()
                  otpEnabled ? setStage(3) : onConfirm()
                }}
              />
            </div>
            <div className='col-6'>
              <NeoButton
                mode='newDesign'
                type='button'
                text={t(DIALOG_KEYS.CONFIRM_NO)}
                onClick={() => {
                  hideConfirmModal()
                  history.push('/beneficiary-transfers/transfers')
                }}
              />
            </div>
          </div>
        </div>
      </Modal>
    ),
    [confirmMessage, otpEnabled],
  )
  useEffect(() => {
    if (location.state === undefined) {
      history.push('/beneficiary-transfers')
      return
    }
    setBeneDetails(location?.state?.beneDetails)
    setTransferType(location?.state?.transferType)
    if (location?.state?.beneDetails?.beneCurrency === currentAccountDetail?.currency) {
      setCurrencyList([location?.state?.beneDetails?.beneCurrency])
    } else {
      setCurrencyList([location?.state?.beneDetails?.beneCurrency, currentAccountDetail?.currency])
    }
    // fetchCurrencyList()
    // fetchInternalCurrencyList()
  }, [currentAccountDetail])

  useEffect(() => {
    getRemarksList()
  }, [])

  const getRemarksList = useCallback(async () => {
    try {
      const response = await DashboardService.getRemarksCategory()
      if (response.status === 200) {
        setLoading(false)
        setRemarksList(response.data.remarks)
      }
    } catch (err) {}
  }, [])

  const onVerify = useCallback(
    async (values) => {
      try {
        const featureDetails = featureList['BENE_IAT']
        if (featureDetails[currentAccountDetail['accountType']] === 'N') {
          setMessage({
            code: t(DIALOG_KEYS.NO_ACCESS),
            message: t(DIALOG_KEYS.NO_ACCOUNTS),
          })
          showModal()
          return
        }

        setLoading(true)
        setFormValues(values)
        if (values.transferAmount === '0.00' || values.transferAmount === '.00') {
          // setMessage({ code: 'Internal', message: 'Amount should be greater than 0 ' })
          // showModal()
          return
        }
        // Compare with selected account balance : temporary solution untill handled by service
        // if (parseInt(currentAccountDetail?.odBal) <= parseInt(values.amount)) {
        //   return
        // }
        const reqParams = {
          fin: {
            srcAccount: currentAccountDetail?.accountNo,
            srcAccBranch: currentAccountDetail?.brnCode,
            srcAccCcy: currentAccountDetail?.currency,
            destAccount: beneDetails?.beneAccNo,
            destAccBranch: '',
            destAccCcy: '',
            destBankName: '',
            bicCode: '',
            sortCode: '',
            txnCurrency: values.txnCurrency,
            amount: values.transferAmount,
            remarks: values.remarks === 'Custom' ? values.customRemarks : values.remarks,
          },
          nfin: {
            transferType: 'IAT',
            beneId: beneDetails?.beneId,
            scheduled: values.isScheduled === 'Yes' ? true : false,
            scheduledDate: values.scheduledDate,
            beneficiaryName: '',
            beneficiaryMail: '',
            beneficiaryMobile: '',
            addBeneficiary: false,
          },
          cdf: {
            FXREFNO: '',
          },
          requestId: 'FTVERIFYIAT',
        }
        const response = await BeneficiaryTransferService.verifyFundTransfer(reqParams)
        if (response.status === 200) {
          setOtpEnabled(response.data['otpEnabled'])
          setVerifyDetails(response.data)
          setConfirmMessage(response.data['message'])
          setStage(2)
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
      }
    },
    [beneDetails, transferType, currentAccountDetail, featureList],
  )

  const onConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const reqParams = {
        fin: {
          srcAccount: currentAccountDetail?.accountNo,
          srcAccBranch: currentAccountDetail?.brnCode,
          srcAccCcy: currentAccountDetail?.currency,
          destAccount: beneDetails?.beneAccNo,
          destAccBranch: '',
          destAccCcy: '',
          destBankName: '',
          bicCode: '',
          sortCode: '',
          txnCurrency: formValues.txnCurrency,
          amount: formValues.transferAmount,
          remarks: formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks,
        },
        nfin: {
          transferType: 'IAT',
          beneId: beneDetails?.beneId,
          scheduled: formValues.isScheduled === 'Yes' ? true : false,
          scheduledDate: formValues.scheduledDate,
          beneficiaryName: '',
          beneficiaryMail: '',
          beneficiaryMobile: '',
          addBeneficiary: false,
          otp: verifyDetails.otpEnabled ? otp : '0000',
        },
        cdf: {
          FXREFNO: '',
        },
        requestId: 'FTCONFIRMIAT',
        module: 'FUNDTRANSFER',
      }
      const response = await BeneficiaryTransferService.confirmFundTransfer(reqParams)
      if (response.status === 200) {
        setSuccessResponse(response.data)
        setMessage(response.data['message'])
        dispatch(setAccRefresh(true))
        setStage(4)
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
      setOtp('')
    }
  }, [beneDetails, transferType, currentAccountDetail, otp, formValues])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirm()
      case 3:
        return <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onConfirm} loading={loading} />
      case 4:
        return (
          <NeoSuccess
            onClick1={() =>
              BeneficiaryTransferService.downLoadReport({
                transRefNum: successResponse.referenceNo,
                refId: '',
                module: 'FUNDTRANSFER',
              })
            }
            module='DOWNLOAD_RECEIPT'
            message={message}
            linkPath='/beneficiary-transfers'
          />
        )
      default:
        return renderForm()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderForm() {
    return (
      <>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <p style={{ fontSize: 10, fontWeight: 600, paddingLeft: 30 }}>To</p>
        <BeneficiaryDisplay beneDetails={beneDetails} />
        <Formik
          initialValues={{
            transferAmount: '',
            remarks: '',
            txnCurrency: beneDetails?.beneCurrency,
            customRemarks: '',
            isScheduled: 'No',
            scheduledDate: '',
          }}
          enableReinitialize
          validationSchema={InternalTransferSchema}
          onSubmit={onVerify}>
          {({ isSubmitting, errors, touched, setFieldValue, handleChange, values }) => (
            <Form>
              <div className='form-group'>
                <NeoInput
                  tabIndex='1'
                  showAsterisk={internalTransferConfig['isAmountRequired']}
                  text={t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.TRANSFER_AMOUNT)}
                  name='amount'
                  onChange={(values) => {
                    setFieldValue('transferAmount', values.value)
                  }}
                  mode='amount'
                />
                <InputError text={errors.transferAmount} touched={touched.transferAmount} />
                <InputError
                  text={t(VALIDATION_MESSAGES.AMOUNT_VALID)}
                  touched={values.transferAmount === '0.00' || values.transferAmount === '.00'}
                />
              </div>

              <div className='mt-3 form-group'>
                <NeoInput
                  tabIndex='2'
                  showAsterisk={internalTransferConfig['isCurrencyRequired']}
                  text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.CURRENCY)}
                  mode='select'
                  name='txnCurrency'
                  onChange={(e) => {
                    handleChange(e)
                  }}
                  list={currencyList}
                  keyValue={null}
                />
                <InputError text={errors.txnCurrency} touched={touched.txnCurrency} />
              </div>
              {config.SCHEDULED_TRANSFERS && (
                <>
                  <div className='mt-3 form-group'>
                    <NeoInput
                      tabIndex='3'
                      showAsterisk={internalTransferConfig['isSchedulePaymentRequired']}
                      text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_TRANSFER)}
                      mode='select'
                      name='isScheduled'
                      onChange={(e) => {
                        handleChange(e)
                      }}
                      list={['Yes', 'No']}
                      keyValue={null}
                    />
                    <InputError text={errors.isScheduled} touched={touched.isScheduled} />
                  </div>

                  {values.isScheduled === 'Yes' && (
                    <div className='form-group mt-3'>
                      <NeoInput
                        tabIndex='4'
                        showAsterisk={internalTransferConfig['isScheduleDateRequired']}
                        name='scheduledDate'
                        text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_DATE)}
                        icon='calendar_today'
                        mode='single'
                        type='date'
                        onChange={handleChange}
                        min={moment(new Date()).format('YYYY-MM-DD')}
                      />
                      <InputError text={errors.scheduledDate} touched={touched.scheduledDate} />
                    </div>
                  )}
                </>
              )}

              <div className='mt-3 form-group'>
                <NeoInput
                  tabIndex='5'
                  showAsterisk={internalTransferConfig['isRemarksRequired']}
                  text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.REMARKS)}
                  mode='select'
                  name='remarks'
                  onChange={(e) => {
                    handleChange(e)
                  }}
                  list={remarksList}
                  keyValue={null}
                />
                <InputError text={errors.remarks} touched={touched.remarks} />
              </div>

              {values.remarks === 'Custom' && (
                <div className='row'>
                  <div className='form-group col-12'>
                    <NeoInput
                      tabIndex='6'
                      showAsterisk={internalTransferConfig['isCustomRemarksRequired']}
                      text={t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.CUSTOM_REMARK)}
                      onChange={handleChange}
                      name='customRemarks'
                      maxLength={config.REMARKS_MAX}
                    />
                    <InputError text={errors.customRemarks} touched={touched.customRemarks} />
                  </div>
                </div>
              )}

              <div className='mt-3'>
                {isSubmitting ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    tabIndex='7'
                    type='submit'
                    mode={'newDesign'}
                    disabled={isSubmitting}
                    text={t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_DETAILS_KEYS.SUBMIT)}
                  />
                )}
              </div>
              <div className='back-cancel-btn-container'>
                <button
                  className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                  tabIndex={'8'}
                  onClick={() => history.goBack()}>
                  {' '}
                  {t(SIDENAV_KEYS.TOUCH_ID_KEYS.CANCEL)}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </>
    )
  }

  function renderConfirm() {
    return (
      <>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <p style={{ fontSize: 10, fontWeight: 600, paddingLeft: 30 }}>To</p>
        <BeneficiaryDisplay beneDetails={beneDetails} />
        <div className='d-flex flex-column confirmation'>
          {/* <div>
            <h6 className='label'>Beneficiary Name</h6>
            <h6 className='value'>{verifyDetails?.beneName}</h6>
          </div>
          <div>
            <h6 className='label'>Beneficiary Branch</h6>
            <h6 className='value'>{verifyDetails?.destBranch}</h6>
          </div> */}
          <div>
            <h6 className='label'>
              {t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.TRANSFER_AMOUNT1)}
            </h6>
            <h6 className='value'>{formValues?.transferAmount}</h6>
          </div>
          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.currency)}</h6>
            <h6 className='value'>{formValues.txnCurrency}</h6>
          </div>
          {config.SCHEDULED_TRANSFERS && (
            <>
              <div>
                <h6 className='label'>{t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_TRANSFER)}</h6>
                <h6 className='value'>{formValues?.isScheduled}</h6>
              </div>
              {formValues.isScheduled === 'Yes' && (
                <div>
                  <h6 className='label'>{t(DEPOSITS_KEYS.TERM_DEPOSITS_KEYS.SCHEDULE_DATE1)}</h6>
                  <h6 className='value'>{moment(formValues.scheduledDate).format('DD-MM-YYYY')}</h6>
                </div>
              )}
            </>
          )}
          <div>
            <h6 className='label'>{t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.CHARGES)}</h6>
            <h6 className='value'>
              <NumberFormat
                value={verifyDetails?.charges || 0}
                displayType={'text'}
                thousandSeparator={true}
                prefix={''}
                fixedDecimalScale={true}
                decimalScale={2}
                allowEmptyFormatting
              />
            </h6>
          </div>
          <div>
            <h6 className='label'>
              {t(REQUESTS_KEYS.CHEQUE_KEYS.STOP_CHEQUE_PAYMENT_KEYS.REMARKS1)}
            </h6>
            <h6 className='value'>
              {formValues.remarks === 'Custom' ? formValues.customRemarks : formValues.remarks}
            </h6>
          </div>

          <div>
            <TermsAndCondition module='BENEFICIARYTRANSFER' />
          </div>

          <div className='mt-3'>
            {loading ? (
              renderLoading()
            ) : (
              <NeoButton
                mode='newDesign'
                type='button'
                className='btn btn-neo'
                onClick={() =>
                  verifyDetails.repeat ? showConfirmModal() : otpEnabled ? setStage(3) : onConfirm()
                }
                text={t(BENEFICIARY_TRANSFER_KEYS.TRANSFER_CONFIRM_KEYS.CONFIRM)}
              />
            )}
          </div>
          <div className='back-cancel-style' onClick={() => setStage(1)}>
            {' '}
            {t(SIDENAV_KEYS.TOUCH_ID_KEYS.BACK)}
          </div>
        </div>
      </>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey='TRANSFER_INTERNAL'>
      <div className='new-design-form-style'>
        <div className='heading-style'>
          {t(BENEFICIARY_TRANSFER_KEYS.BENEFICIARY_TRANSFER.INTERNAL_TRANSFER_TITLE)}
        </div>

        <div>{renderSwitch()}</div>
      </div>
    </LayoutWithAccountCard>
  )
}
